enum ExceptionsInvolvedEnum {
    FIRST_INDENT_OF_ARTICLE_4_1_A = 'FIRST_INDENT_OF_ARTICLE_4_1_A',
    SECOND_INDENT_OF_ARTICLE_4_1_A = 'SECOND_INDENT_OF_ARTICLE_4_1_A',
    THIRD_INDENT_OF_ARTICLE_4_1_A = 'THIRD_INDENT_OF_ARTICLE_4_1_A',
    FOURTH_INDENT_OF_ARTICLE_4_1_A = 'FOURTH_INDENT_OF_ARTICLE_4_1_A',
    ARTICLE_4_1_B = 'ARTICLE_4_1_B',
    FIRST_INDENT_OF_ARTICLE_4_2 = 'FIRST_INDENT_OF_ARTICLE_4_2',
    SECOND_INDENT_OF_ARTICLE_4_2 = 'SECOND_INDENT_OF_ARTICLE_4_2',
    THIRD_INDENT_OF_ARTICLE_4_2 = 'THIRD_INDENT_OF_ARTICLE_4_2',
    FIRST_SUBPARAGRAPH_OF_ARTICLE_4_3 = 'FIRST_SUBPARAGRAPH_OF_ARTICLE_4_3',
    SECOND_SUBPARAGRAPH_OF_ARTICLE_4_3 = 'SECOND_SUBPARAGRAPH_OF_ARTICLE_4_3'

}

namespace ExceptionsInvolvedEnum {

    type AdditionalFields = { resourceKey: string };
    export type Entry = { enumKey: string } & AdditionalFields;

    const fieldsMap: Map<ExceptionsInvolvedEnum, AdditionalFields> = new Map(
        [
            [ExceptionsInvolvedEnum.FIRST_INDENT_OF_ARTICLE_4_1_A, {resourceKey: 'easeportal.enum.portal.FIRST_INDENT_OF_ARTICLE_4_1_A'}],
            [ExceptionsInvolvedEnum.SECOND_INDENT_OF_ARTICLE_4_1_A,
                {resourceKey: 'easeportal.enum.portal.SECOND_INDENT_OF_ARTICLE_4_1_A'}],
            [ExceptionsInvolvedEnum.THIRD_INDENT_OF_ARTICLE_4_1_A, {resourceKey: 'easeportal.enum.portal.THIRD_INDENT_OF_ARTICLE_4_1_A'}],
            [ExceptionsInvolvedEnum.FOURTH_INDENT_OF_ARTICLE_4_1_A,
                {resourceKey: 'easeportal.enum.portal.FOURTH_INDENT_OF_ARTICLE_4_1_A'}],
            [ExceptionsInvolvedEnum.ARTICLE_4_1_B, {resourceKey: 'easeportal.enum.portal.ARTICLE_4_1_B'}],
            [ExceptionsInvolvedEnum.FIRST_INDENT_OF_ARTICLE_4_2, {resourceKey: 'easeportal.enum.portal.FIRST_INDENT_OF_ARTICLE_4_2'}],
            [ExceptionsInvolvedEnum.SECOND_INDENT_OF_ARTICLE_4_2, {resourceKey: 'easeportal.enum.portal.SECOND_INDENT_OF_ARTICLE_4_2'}],
            [ExceptionsInvolvedEnum.THIRD_INDENT_OF_ARTICLE_4_2, {resourceKey: 'easeportal.enum.portal.THIRD_INDENT_OF_ARTICLE_4_2'}],
            [ExceptionsInvolvedEnum.FIRST_SUBPARAGRAPH_OF_ARTICLE_4_3,
                {resourceKey: 'easeportal.enum.portal.FIRST_SUBPARAGRAPH_OF_ARTICLE_4_3'}],
            [ExceptionsInvolvedEnum.SECOND_SUBPARAGRAPH_OF_ARTICLE_4_3,
                {resourceKey: 'easeportal.enum.portal.SECOND_SUBPARAGRAPH_OF_ARTICLE_4_3'}]
        ]);

    // Note: Without Array.from() the 'let ... of' loops cause: "type 'IterableIterator<>'
    // is not an array type or a string type" error when --downlevelIteration is not set
    // In any case here we do not stop to entries() IterableIterator.
    // We further map from [key: {resourceKey: }] to {enumKey: , resourceKey:}
    export const entries: Array<Entry> = Array.from(fieldsMap.entries()).map((v) => ({enumKey: v[0], ...v[1]}));
    // values of the enumerator
    export const values: Array<ExceptionsInvolvedEnum> = Array.from(fieldsMap.keys());

    export const resourceKey = (e: ExceptionsInvolvedEnum): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        }// strictNullChecks require this
        return x.resourceKey;
    };

    export const enumKey = (e: string): ExceptionsInvolvedEnum => {
        const x = ExceptionsInvolvedEnum.values.filter(v => v == e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        } // strictNullChecks require this
        return x[0];
    };

    export const resourceSelectKey = (e: ExceptionsInvolvedEnum): string => {
        const x = fieldsMap.get(e);
        if (x === undefined) {
            throw Error('Invalid enum value');
        }// strictNullChecks require this
        return x.resourceKey;
    };

}

export { ExceptionsInvolvedEnum };
